define('SageDotCom/DataLayer/Events/bottomNav',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function ButtonClickEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = "bottom_nav"; // overwrite name
    }

    ButtonClickEvent.prototype = Object.create(EventBase.prototype);

    ButtonClickEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope) {
        var eventData = {
            'event_name': this.getName(),
            'event_non-int': "0",
            'event_category': "component",
            'event_action': "bottom_nav_select"
        }

        if (scope) {
            var lbl = $(scope).text() || "";
            var section = $(scope).prevAll("p:first, .score-content-spot:first").text() || "";
            eventData = $.extend(eventData, {
                'event_label': this.stripHtml(lbl.trim()), // strip any html
                'event_name_level_1': this.getId(scope),
                'event_name_level_2': $(scope).attr("href") || $("a:first", scope).attr("href") || "",
                'event_name_level_3': section.trim(),
                'event_name_level_4': ""
            });
        }

        return eventData;
    }

    return new ButtonClickEvent();
});
